import React from "react";
import classes from "./SponsorEventsForm.module.css"

import Button from "../../../UI/Button/Button";

const SponsorEventsForm = props =>{
    return <div className={classes.container}>
        <h2>COMING SOON...</h2>
    </div>
}
export default SponsorEventsForm